// src/pages/RunData.jsx
import { Box, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import RunDataView from "../components/RunDataView";

export default function RunData() {
  const { id } = useParams();

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Detailed data
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Browse run data from BigQuery (1000+ rows supported).
      </Typography>
      <RunDataView runId={id} />
    </Box>
  );
}
